// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","logo__img":"Logo_logo__img__zmYBe","logo__title":"Logo_logo__title__C53Dh","logo__title_mob":"Logo_logo__title_mob__E2R8o"};